<template>
  <div class="pa-3">

    <v-card :loading="isLoadig" class="mx-auto" max-width="600" elevation="0">
      <v-card-title>
        {{ currentPrivateHelpRequestForm.title }}
      </v-card-title>

      <v-card-subtitle>
        {{ currentPrivateHelpRequestForm.description }}
      </v-card-subtitle>

      

      <v-card-text>
        <div v-if="currentPrivateHelpRequestForm.isClosed">
          تم الاكتفاء بعدد الطلبات المقدمة
        </div>
        <div v-else
          class="my-2"
          v-for="field in currentPrivateHelpRequestForm.fields"
          :key="field.id"
        >
          <v-text-field
            v-model="helpRequestInputFields[`${field.id}`].text"
            v-if="field.type == 'TextField'"
            :rules="field.isRequired ? [rules.required] : []"
            :label="field.title"
            :hint="field.hint"
            persistent-hint
          ></v-text-field>

          <v-textarea
            v-model="helpRequestInputFields[`${field.id}`].text"
            v-if="field.type == 'TextArea'"
            outlined
            :label="field.title"
          ></v-textarea>

          <v-select
            v-model="helpRequestInputFields[`${field.id}`].selectedOptionId"
            v-if="field.type == 'Dropdown'"
            :items="field.options"
            :label="field.title"
            item-text="title"
            item-value="id"
          ></v-select>

          <div v-if="field.type == 'Radio'">
            <p>{{ field.title }}</p>
            <v-radio-group
              v-model="helpRequestInputFields[`${field.id}`].selectedOptionId"
            >
              <v-radio
                v-for="r in field.options"
                :key="r.id"
                :label="r.title"
                :value="r.id"
              ></v-radio>
            </v-radio-group>
          </div>

          <ImageUploadComponent
            :title="field.title"
            v-if="field.type == 'ImageUpload'"
            v-bind:imageName.sync="helpRequestInputFields[`${field.id}`].imageName"
          ></ImageUploadComponent>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn :disabled="currentPrivateHelpRequestForm.isClosed" :loading="isSending" @click="sendRequest" dark block> ارسال الطلب </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ImageUploadComponent from "@/components/ImageUploadComponent";
export default {
  name: "SubmitHelpRequest",


  //********************** */
  components: { ImageUploadComponent },

  //********************** */
  data: () => ({
      isSending: false,
      isLoadig: false,
      formId:-1,
      privateKey:"",
    helpRequestInputFields: {},
    rules: {
      required: (value) => !!value || "هذا الحقل مطلوب",
    },
  }),

  //********************** */
  computed: {
    ...mapGetters("Catalog", {
      currentPrivateHelpRequestForm: "currentPrivateHelpRequestForm",
    }),
  },

  //********************** */
  methods: {
    sendRequest: async function () {
      let model = {
          formId: this.formId,
          fields: Object.values(this.helpRequestInputFields),
          key: this.privateKey
      };
      this.isSending = true;
      try {
          await this.$store.dispatch("Help/createPrivateHelpRequest", model);
          this.isSending = false;
          this.$router.push({ name: 'RequestReceived'});

      } catch (error) {
          this.isSending = false;
          alert(error);
      }
      
    },
    loadRequestForm: async function () {
      let key = this.$route.query.k;
      this.privateKey = key;
      this.isLoadig = true;
      try {
        await this.$store.dispatch(
          "Catalog/loadCurrentPrivateHelpRequestFormByKey",
          key
        );
        this.fillHelpRequestInputFields();
        this.formId = this.currentPrivateHelpRequestForm.id;
        console.log(this.helpRequestInputFields);
        this.isLoadig = false;
      } catch (error) {
          this.isLoadig = false;
        alert(error);
      }
    },

    fillHelpRequestInputFields: function () {
      for (
        let index = 0;
        index < this.currentPrivateHelpRequestForm.fields.length;
        index++
      ) {
        const element = this.currentPrivateHelpRequestForm.fields[index];

        let input = {
          type: element.type,
          id: element.id,
          isRequired: element.isRequired,
          selectedOptionId: -1,
          text: "",
          imageName: "",
          imageFile: "",
        };

        this.helpRequestInputFields[`${element.id}`] = input;
        
      }
    },
  },

  //*********************** */
  async mounted() {
    await this.loadRequestForm();
  },
};
</script>

<style>
</style>